module.exports = __webpack_public_path__ + "static/miss-monique_2-a13c00311ee1b170e67a3292fe4add1e.jpg";